<echo-nx-webcam-scanner (imageScanned)="onImageScanned($event)"></echo-nx-webcam-scanner>
